<template>
<div>

<ContentHeader :title="$store.state.languages.lang_phrases.markalar"  :show_button="false" ></ContentHeader>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<div class="mt-4">

<div class="grid" v-for="item in list" >
<div class="col-12">
<div class="flex align-items-center justify-content-between" >
<p class="text-primary"><b>{{item.brand.name}}</b></p>

<Button type="button" icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm mt-3" @click="deleteItem('plannerbrand',item.id)"></Button>
</div>
</div>
</div>


<ClickAddSelect  :title="$store.state.languages.lang_phrases.yeni_ekle"  valkey="brand_id" @newAdded="newAdded" :options="brands"></ClickAddSelect>

</div>
</template>
 </div> 
</template>

<script>
export default {

  name: 'PlannerBrands',

  data () {
    return {
      list:[],
      brands:[],
      loading:true,
    }
  },
  mounted()
  {
    this.getData()
  },
  computed:{
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    }
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
      if(newVal)
      {
        this.getData()
      }
    }
  },
  methods:{
    async getData()
    {
      this.brands = await this.generalApiGetWithoutLoader("brands")
      this.list = await this.generalApiGetWithoutLoader("planner_brands/"+this.$route.params.id)
      this.loading = false
    },
    newAdded(data)
    {
      console.log(data);
      //return
      

      let formdata = new FormData()
      formdata.append("brand_id",data.value)    
      this.generalSubmission(formdata,"submit_planner_brand/"+this.$route.params.id,this.afternewAdded)
    },
    afternewAdded(response)
    {
      console.log(response.data)
      this.getData()     

    },
  }
};
</script>

<style lang="css" scoped>
</style>